<template>
  <div>
    <div class="title-size mb-30 text-center">
      {{ $t('text.manufacturers') | firstLetterCapitalize }}
    </div>
    <div class="section-title mb-20">
      <b-button
        size="sm"
        variant="outline-success"
        class="min-w-80"
        @click="add()"
        v-if="p('Products.Manufacturers.Add')"
        >{{ $t('text.add') | firstLetterCapitalize }}</b-button
      >
      <span class="right-float">
        <img src="@/assets/filter.svg" />
        <el-input
          v-model="filter"
          size="mini"
          class="search-input filter-input"
          placeholder="filter by code or name"
        ></el-input>
      </span>
    </div>
    <el-table
      border
      ref="table"
      :data="tableData"
      size="small"
      class="mb-30"
      v-loading="loading"
    >
      <!-- <el-table-column
        :label="$t('text.code') | firstLetterCapitalize"
        prop="manufacturerCode"
      >
      </el-table-column> -->
      <el-table-column
        :label="$t('text.name') | firstLetterCapitalize"
        prop="name"
      >
      </el-table-column>
      <el-table-column
        :label="$t('text.address') | firstLetterCapitalize"
        prop="address"
      >
      </el-table-column>
      <el-table-column
        :label="$t('text.contact') | firstLetterCapitalize"
        prop="contact"
      >
      </el-table-column>
      <el-table-column
        :label="$t('text.action') | firstLetterCapitalize"
        min-width="120"
        fixed="right"
        v-if="p('Products.Manufacturers.Edit')"
      >
        <template slot-scope="scope">
          <b-button
            size="sm"
            variant="outline-success"
            class="min-w-80"
            @click="edit(scope.row)"
            >{{ $t('text.view') | firstLetterCapitalize }}/{{
              $t('text.edit') | firstLetterCapitalize
            }}</b-button
          >
        </template>
      </el-table-column>
    </el-table>
    <EditManufacturers ref="editManufacturers" />
  </div>
</template>

<script>
import EditManufacturers from '@/components/products/manufacturers/EditManufacturers'
import ApiService from '@/services/CommonApiService.js'
import { subscriptionCodeStatus } from '../../../const'
export default {
  data() {
    return {
      subscriptionCodeStatus,
      tableData: [],
      loading: false,
      filter: '',
      timer: ''
    }
  },
  components: {
    EditManufacturers
  },
  mounted: function() {
    this.getData()
  },
  computed: {
    statusFontClass() {
      return status => {
        let className = ''
        switch (status) {
          case this.subscriptionCodeStatus.trial:
            className = 'red-font'
            break
          case this.subscriptionCodeStatus.approved:
            className = 'green-font'
            break
          default:
            className = 'dark-grey-font'
        }
        return className
      }
    }
  },
  watch: {
    filter() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
      this.timer = setTimeout(this.getData, 500)
    }
  },
  methods: {
    filterHandler(value, row, column) {
      const property = column['property']
      return row[property] === value
    },
    getData() {
      this.loading = true
      ApiService.GetManufactures()
        .then(response => {
          this.loading = false
          this.tableData = response.data.data
          if (this.filter) {
            this.tableData = this.tableData.filter(item => {
              return (
                item.name.toLowerCase().indexOf(this.filter.toLowerCase()) >
                  -1 ||
                item.manufacturerCode
                  .toLowerCase()
                  .indexOf(this.filter.toLowerCase()) > -1
              )
            })
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    add() {
      this.$refs.editManufacturers.openDialog()
    },
    edit(row) {
      this.$refs.editManufacturers.openDialog()
      this.$refs.editManufacturers.form = JSON.parse(JSON.stringify(row))
    }
  }
}
</script>
